import { z } from 'zod/v4';

export const crashLogItemSchema = z.object({
  key: z.string(),
  lastModified: z.string(),
  presignedURL: z.string(),
  size: z.number(),
  storageClass: z.object({
    value: z.string(),
  }),
});

export type CrashLogItem = z.infer<typeof crashLogItemSchema>;
